/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ruian_Resolve_FailedInputs */

const cs_ruian_resolve_failed = /** @type {(inputs: Ruian_Resolve_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresu RÚIAN se nepodařilo načíst. Zkuste jiný návrh.`)
};

const en_ruian_resolve_failed = /** @type {(inputs: Ruian_Resolve_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not resolve that RÚIAN address. Try another suggestion.`)
};

/**
* | output |
* | --- |
* | "Could not resolve that RÚIAN address. Try another suggestion." |
*
* @param {Ruian_Resolve_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ruian_resolve_failed = /** @type {((inputs?: Ruian_Resolve_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ruian_Resolve_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ruian_resolve_failed(inputs)
	return cs_ruian_resolve_failed(inputs)
});